// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Flatlogic Dashboards (https://flatlogic.com/admin-dashboards)
 *
 * Copyright © 2015-present Flatlogic, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/*
 * Typography
 * ======================================================================== */
 :root {
  --font-size-base: 1rem;
  --font-size-lg: 1.25rem;
  --font-size-sm: 0.875rem;
  --font-size-large: 1.1rem;
  --font-size-small: 0.9rem;
  --font-size-index: 0.7rem;
  --font-family-base: 'Nunito', 'HelveticaNeue-Light', sans-serif;
  
  --line-height-computed: 1.5rem;
  
  --font-weight-thin: 300;
  --font-weight-normal: 400;
  --font-weight-semi-bold: 600;
  --font-weight-bold: 700;
  
  --gray-100: #f9f6f2;
  --gray-200: #f7f7f7;
  --gray-300: #cccbca;
  --gray-400: #ccc;
  --gray-500: #666;
  --gray-600: #6c757d;
  --gray-700: #4d4d4d;
  --gray-800: #343a40;
  --gray-900: #212529;
  
  --gray-light: var(--gray-100);
  --text-muted: var(--gray-300);


    -blue: #007bff;
    --indigo: #6610f2;
    --purple: #6f42c1;
    --pink: #e83e8c;
    --red: #dc3545;
    --orange: #fd7e14;
    --yellow: #ffc107;
    --green: #28a745;
    --teal: #20c997;
    --cyan: #17a2b8;
    --white: #fff;
    --gray: #6c757d;
    --gray-dark: #343a40;
    --primary: #3754a5;
    --secondary: #beccfd;
    --success: #1ab394;
    --info: #5d80f9;
    --warning: #f3c363;
    --danger: #eb3349;
    --light: #cccbca;
    --dark: #343a40;
    --inverse: #4d4d4d;
    --gray: #ccc;
    --default: #f8f8f8;
    --breakpoint-xs: 0;
    --breakpoint-sm: 576px;
    --breakpoint-md: 768px;
    --breakpoint-lg: 992px;
    --breakpoint-xl: 1200px;
    --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;

  
  --brand-primary: #3754a5; /* #337ab7 */
  --brand-secondary: #beccfd;
  --brand-success: #1ab394;
  --brand-info: #5d80f9;
  --brand-warning: #f3c363;
  --brand-danger: #eb3349;
  
  --text-color: var(--gray-700);
  --link-color: #337ab7;
  
  --alert-success-bg: #e6fff2;
  --alert-success-text: var(--brand-success);
  --alert-success-border: rgba(var(--alert-success-text), 0.15);
  
  --alert-info-bg: #d2f1fb;
  --alert-info-text: var(--link-color);
  --alert-info-border: rgba(var(--alert-info-text), 0.09);
  
  --alert-warning-bg: #fff8e6;
  --alert-warning-text: darken(var(--brand-warning), 5%);
  --alert-warning-border: rgba(var(--brand-warning), 0.2);
  
  --alert-danger-bg: #fbdcd7;
  --alert-danger-text: var(--brand-danger);
  --alert-danger-border: rgba(var(--alert-danger-text), 0.09);
  
  /* Gradients */
  --logo-gradient: linear-gradient(to right, var(--brand-danger), #f45c43);
  
  /* Iconography */
  --icon-font-path: '../../node_modules/bootstrap-sass/assets/fonts/bootstrap/'; /* overriding bootstrap variable */
  
  /*
   * Layout
   * ======================================================================== */
  
  --max-content-width: 1000px;
  
  --grid-float-breakpoint: 0;
  
  --body-bg: var(--gray-200);
  
  /*
   * Media queries breakpoints
   * ======================================================================== */
  
  --screen-xs-min: 480px;  /* Extra small screen / phone */
  --screen-sm-min: 768px;  /* Small screen / tablet */
  --screen-md-min: 992px;  /* Medium screen / desktop */
  --screen-lg-min: 1200px; /* Large screen / wide desktop */
  
  /* Components */
  
  --content-padding-horizontal: 30px;
  --content-padding-vertical: 40px;
  
  --navbar-bg-color: #fff;
  --navbar-height: 75px;
  --navbar-border-radius: 0;
  --navbar-margin-bottom: calc(-1 * var(--navbar-height));
  
  --sidebar-width-open: 235px;
  --sidebar-transition-time: 0.3s;
  
  --sidebar-bg-color: #fff;
  --sidebar-color: #4d4d4d;
  
  --breadcrumb-separator: '>';
  --breadcrumb-padding-horizontal: 0;
  
  --badge-font-weight: 600;
  
  --breadcrumb-divider: '>';
  --breadcrumb-padding-y: 0;
  --breadcrumb-padding-x: 0;
  --breadcrumb-bg: transparent;
  
  --widget-bg: #fff;
  --widget-title-color: #444;
  --widget-padding-y: 15px;
  --widget-padding-x: 20px;
  
  --btn-inverse-color: #fff;
  --btn-inverse-border: #414749;
  
  --input-height-small: 2rem;
  
  --enable-rounded: false;
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF;;6EAE6E;CAC5E;EACC,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,+DAA+D;;EAE/D,8BAA8B;;EAE9B,uBAAuB;EACvB,yBAAyB;EACzB,4BAA4B;EAC5B,uBAAuB;;EAEvB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,6BAA6B;EAC7B,6BAA6B;;;IAG3B,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,+MAA+M;IAC/M,6GAA6G;;;EAG/G,wBAAwB,EAAE,YAAY;EACtC,0BAA0B;EAC1B,wBAAwB;EACxB,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;;EAEvB,6BAA6B;EAC7B,qBAAqB;;EAErB,2BAA2B;EAC3B,0CAA0C;EAC1C,6DAA6D;;EAE7D,wBAAwB;EACxB,oCAAoC;EACpC,uDAAuD;;EAEvD,2BAA2B;EAC3B,sDAAsD;EACtD,uDAAuD;;EAEvD,0BAA0B;EAC1B,wCAAwC;EACxC,2DAA2D;;EAE3D,cAAc;EACd,wEAAwE;;EAExE,gBAAgB;EAChB,6EAA6E,EAAE,kCAAkC;;EAEjH;;+EAE6E;;EAE7E,2BAA2B;;EAE3B,0BAA0B;;EAE1B,0BAA0B;;EAE1B;;+EAE6E;;EAE7E,sBAAsB,GAAG,+BAA+B;EACxD,sBAAsB,GAAG,0BAA0B;EACnD,sBAAsB,GAAG,4BAA4B;EACrD,uBAAuB,EAAE,gCAAgC;;EAEzD,eAAe;;EAEf,kCAAkC;EAClC,gCAAgC;;EAEhC,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,uDAAuD;;EAEvD,2BAA2B;EAC3B,+BAA+B;;EAE/B,wBAAwB;EACxB,wBAAwB;;EAExB,2BAA2B;EAC3B,kCAAkC;;EAGlC,wBAAwB;;EAExB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,4BAA4B;;EAE5B,iBAAiB;EACjB,0BAA0B;EAC1B,wBAAwB;EACxB,wBAAwB;;EAExB,yBAAyB;EACzB,6BAA6B;;EAE7B,0BAA0B;;EAE1B,uBAAuB;AACzB","sourcesContent":["/*\n * Flatlogic Dashboards (https://flatlogic.com/admin-dashboards)\n *\n * Copyright © 2015-present Flatlogic, LLC. All rights reserved.\n *\n * This source code is licensed under the MIT license found in the\n * LICENSE.txt file in the root directory of this source tree.\n */\n\n/*\n * Typography\n * ======================================================================== */\n :root {\n  --font-size-base: 1rem;\n  --font-size-lg: 1.25rem;\n  --font-size-sm: 0.875rem;\n  --font-size-large: 1.1rem;\n  --font-size-small: 0.9rem;\n  --font-size-index: 0.7rem;\n  --font-family-base: 'Nunito', 'HelveticaNeue-Light', sans-serif;\n  \n  --line-height-computed: 1.5rem;\n  \n  --font-weight-thin: 300;\n  --font-weight-normal: 400;\n  --font-weight-semi-bold: 600;\n  --font-weight-bold: 700;\n  \n  --gray-100: #f9f6f2;\n  --gray-200: #f7f7f7;\n  --gray-300: #cccbca;\n  --gray-400: #ccc;\n  --gray-500: #666;\n  --gray-600: #6c757d;\n  --gray-700: #4d4d4d;\n  --gray-800: #343a40;\n  --gray-900: #212529;\n  \n  --gray-light: var(--gray-100);\n  --text-muted: var(--gray-300);\n\n\n    -blue: #007bff;\n    --indigo: #6610f2;\n    --purple: #6f42c1;\n    --pink: #e83e8c;\n    --red: #dc3545;\n    --orange: #fd7e14;\n    --yellow: #ffc107;\n    --green: #28a745;\n    --teal: #20c997;\n    --cyan: #17a2b8;\n    --white: #fff;\n    --gray: #6c757d;\n    --gray-dark: #343a40;\n    --primary: #3754a5;\n    --secondary: #beccfd;\n    --success: #1ab394;\n    --info: #5d80f9;\n    --warning: #f3c363;\n    --danger: #eb3349;\n    --light: #cccbca;\n    --dark: #343a40;\n    --inverse: #4d4d4d;\n    --gray: #ccc;\n    --default: #f8f8f8;\n    --breakpoint-xs: 0;\n    --breakpoint-sm: 576px;\n    --breakpoint-md: 768px;\n    --breakpoint-lg: 992px;\n    --breakpoint-xl: 1200px;\n    --font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n\n  \n  --brand-primary: #3754a5; /* #337ab7 */\n  --brand-secondary: #beccfd;\n  --brand-success: #1ab394;\n  --brand-info: #5d80f9;\n  --brand-warning: #f3c363;\n  --brand-danger: #eb3349;\n  \n  --text-color: var(--gray-700);\n  --link-color: #337ab7;\n  \n  --alert-success-bg: #e6fff2;\n  --alert-success-text: var(--brand-success);\n  --alert-success-border: rgba(var(--alert-success-text), 0.15);\n  \n  --alert-info-bg: #d2f1fb;\n  --alert-info-text: var(--link-color);\n  --alert-info-border: rgba(var(--alert-info-text), 0.09);\n  \n  --alert-warning-bg: #fff8e6;\n  --alert-warning-text: darken(var(--brand-warning), 5%);\n  --alert-warning-border: rgba(var(--brand-warning), 0.2);\n  \n  --alert-danger-bg: #fbdcd7;\n  --alert-danger-text: var(--brand-danger);\n  --alert-danger-border: rgba(var(--alert-danger-text), 0.09);\n  \n  /* Gradients */\n  --logo-gradient: linear-gradient(to right, var(--brand-danger), #f45c43);\n  \n  /* Iconography */\n  --icon-font-path: '../../node_modules/bootstrap-sass/assets/fonts/bootstrap/'; /* overriding bootstrap variable */\n  \n  /*\n   * Layout\n   * ======================================================================== */\n  \n  --max-content-width: 1000px;\n  \n  --grid-float-breakpoint: 0;\n  \n  --body-bg: var(--gray-200);\n  \n  /*\n   * Media queries breakpoints\n   * ======================================================================== */\n  \n  --screen-xs-min: 480px;  /* Extra small screen / phone */\n  --screen-sm-min: 768px;  /* Small screen / tablet */\n  --screen-md-min: 992px;  /* Medium screen / desktop */\n  --screen-lg-min: 1200px; /* Large screen / wide desktop */\n  \n  /* Components */\n  \n  --content-padding-horizontal: 30px;\n  --content-padding-vertical: 40px;\n  \n  --navbar-bg-color: #fff;\n  --navbar-height: 75px;\n  --navbar-border-radius: 0;\n  --navbar-margin-bottom: calc(-1 * var(--navbar-height));\n  \n  --sidebar-width-open: 235px;\n  --sidebar-transition-time: 0.3s;\n  \n  --sidebar-bg-color: #fff;\n  --sidebar-color: #4d4d4d;\n  \n  --breadcrumb-separator: '>';\n  --breadcrumb-padding-horizontal: 0;\n  --breadcrumb-bg: transparent;\n  \n  --badge-font-weight: 600;\n  \n  --breadcrumb-divider: '>';\n  --breadcrumb-padding-y: 0;\n  --breadcrumb-padding-x: 0;\n  --breadcrumb-bg: transparent;\n  \n  --widget-bg: #fff;\n  --widget-title-color: #444;\n  --widget-padding-y: 15px;\n  --widget-padding-x: 20px;\n  \n  --btn-inverse-color: #fff;\n  --btn-inverse-border: #414749;\n  \n  --input-height-small: 2rem;\n  \n  --enable-rounded: false;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
